import type { ReactNode } from 'react';
import styles from './InfoCard.module.css';

export interface InfoCardRow {
  label: string;
  value: string | ReactNode;
}

interface InfoCardProps {
  rows: InfoCardRow[];
  title?: string;
  children: ReactNode;
}

export default function InfoCard({ rows, title, children }: InfoCardProps) {
  return (
    <span className={styles.wrapper}>
      {children}
      {rows.length > 0 && (
        <span className={styles.card} role="tooltip">
          {title && <span className={styles.title}>{title}</span>}
          {rows.map((row, i) => (
            <span key={i} className={styles.row}>
              <span className={styles.label}>{row.label}</span>
              <span className={styles.value}>{row.value}</span>
            </span>
          ))}
        </span>
      )}
    </span>
  );
}
